import { useEffect, useState } from "react";
import {
  MenuItem,
  Select,
  TextField,
  IconButton,
  Box,
  Typography,
  FormControl,
  InputLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const SelectableEditableFilter = ({
  optionData = [],
  fieldLabel = "optionname",
  label = "Select Option",
  value = "",
  onChange,
  onEdit,
  onDelete,
  ...props
}) => {
  const [options, setOptions] = useState(optionData);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editText, setEditText] = useState("");

  useEffect(() => {
    setOptions(optionData);
  }, [optionData]);

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditText(options[index][fieldLabel]);
  };

  const handleSave = (index) => {
    const updated = [...options];
    updated[index][fieldLabel] = editText?.trim();
    setEditingIndex(null);
    onEdit?.(updated[index]);
  };

  const handleDelete = (index) => {
    const deletedItem = options[index];
    onDelete?.(deletedItem);
  };

  const handleChange = (event) => {
    onChange?.(event.target.value);
  };
  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={handleChange}
        sx={{
          height: 40,
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            height: "100%",
          },
        }}
        renderValue={(selected) =>
          selected ? (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width={"100%"}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography sx={{ flexGrow: 1 }}>
                {selected[fieldLabel]}
              </Typography>
              <IconButton
                size="small"
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation(); 
                  onChange?.("");
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          ) : (
            <Typography color="text.primary">Select {label}</Typography>
          )
        }
      >
      {options?.length > 0 ? (
        options?.map((option, index) => (
          <MenuItem key={index} value={option} disableRipple>
            {editingIndex === index ? (
              <Box
                display="flex"
                alignItems="center"
                width="100%"
                onClick={(e) => e.stopPropagation()}
              >
                <TextField
                  size="small"
                  name={props?.name}
                  label={props?.label}
                  value={editText}
                  onChange={(e) => setEditText(e.target.value)}
                  sx={{ mr: 1, flexGrow: 1 }}
                />
                <IconButton onClick={() => handleSave(index)} size="small">
                  <CheckIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={() => setEditingIndex(null)} size="small">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            ) : (
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
              >
                <Typography>{option[fieldLabel]}</Typography>
                <Box>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEdit(index);
                    }}
                    size="small"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(index);
                    }}
                    size="small"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </Box>
            )}
          </MenuItem>
        ))
        ) : (
          <MenuItem disabled>
            <Typography color="text.primary">No options</Typography>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default SelectableEditableFilter;
